import React from 'react';
import { ClipboardListIcon, SearchIcon, FileCheckIcon, CheckCircleIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: ClipboardListIcon,
    title: 'Initial Consultation',
    description: 'Share your business needs and funding requirements with our expert team.'
  }, {
    icon: SearchIcon,
    title: 'Lender Matching',
    description: 'We analyze your profile and match you with the best lending partners.'
  }, {
    icon: FileCheckIcon,
    title: 'Application & Negotiation',
    description: 'We handle the paperwork and negotiate favorable terms on your behalf.'
  }, {
    icon: CheckCircleIcon,
    title: 'Funding Approval',
    description: 'Receive your funds quickly and start growing your business.'
  }];
  return <section id="how-it-works" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-378">
      <div className="max-w-7xl mx-auto" data-id="element-379">
        <div className="text-center mb-16" data-id="element-380">
          <h2 className="text-4xl font-bold text-blue-900 mb-4" data-id="element-381">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-382">
            Our streamlined process makes securing business funding simple and
            stress-free.
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8" data-id="element-383">
          {steps.map((step, index) => <div key={index} className="relative text-center" data-id="element-384">
              <div className="bg-blue-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-385">
                <step.icon className="w-10 h-10 text-blue-900" data-id="element-386" />
              </div>
              <div className="absolute top-10 left-1/2 w-full h-0.5 bg-blue-200 -z-10 hidden md:block" style={{
            display: index === steps.length - 1 ? 'none' : 'block'
          }} data-id="element-387" />
              <div className="bg-[#0066CC] text-white w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-388">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-389">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-390">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}